import React, { useContext, useEffect, useState, useRef } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { History, Save } from "@mui/icons-material";

import ControlBar from '../structure/ControlBar';
import ControlButton from '../structure/ControlButton';
import ControlDivider from '../structure/ControlDivider';

import FileUploadIcon from '@mui/icons-material/FileUpload';
import UploadLUTDialog from '../dialog/UploadLUTDialog';
import SaveButton from '../buttons/SaveButton';

export default function LUTViewMenuBar(props) {
    const { retrieveLuts, onSave, onRevert, saveDisabled, status, statusColor } = props;
    const [openLutDialog, setOpenLutDialog] = useState(false);

    const handleOpenDialog = () => {
        setOpenLutDialog(!openLutDialog)
    }

    return (
        <React.Fragment>
            <UploadLUTDialog
                open={openLutDialog}
                setOpen={handleOpenDialog}
                retrieveLuts={retrieveLuts}
            />
            <ControlBar>
                    <Tabs
                        value={0}
                        indicatorColor="secondary"
                        variant="scrollable"
                        scrollButtons="auto">
                        <Tab
                            label={<Box display="flex" alignItems="center">Manage LUTs</Box>}
                            style={{ textTransform: 'none', fontWeight: 'bold', color: 'white' }}
                        />
                    </Tabs>
                    {
                        <React.Fragment>
                            <ControlDivider />
                            <ControlButton
                                title='Upload File'
                                clicked={handleOpenDialog}
                            >
                                <FileUploadIcon id='upload-view-upload-button' style={{fill: 'white'}} />
                            </ControlButton>
                            <ControlDivider />
                            <SaveButton
                                title="Save"
                                clicked={onSave}
                                disabled={saveDisabled}
                                status={status}
                                statusColor={statusColor}
                            >
                                <Save style={{ color: "white" }} />
                            </SaveButton>
                            <SaveButton
                                title="Revert"
                                clicked={onRevert}
                                disabled={saveDisabled}
                            >
                                <History style={{ color: "red" }} />
                            </SaveButton>
                        </React.Fragment>
                    }
            </ControlBar>
        </React.Fragment>
    );
}